import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCode = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.8 33.2 9.6 24l9.2-9.2L16 12 4 24l12 12zm10.4 0 9.2-9.2-9.2-9.2L32 12l12 12-12 12z" })
});
export default SvgCode;
